import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { CSSProperties } from 'react';
import { css } from 'styled-components';

export interface BorderProps {
    border: CSSProperties['border'];
    b: CSSProperties['border'];

    bt: CSSProperties['borderTop'];
    borderTop: CSSProperties['borderTop'];
    br: CSSProperties['borderRight'];
    borderRight: CSSProperties['borderRight'];
    bb: CSSProperties['borderBottom'];
    borderBottom: CSSProperties['borderBottom'];
    bl: CSSProperties['borderLeft'];
    borderLeft: CSSProperties['borderLeft'];

    bw: CSSProperties['borderWidth'];
    borderWidth: CSSProperties['borderWidth'];
    btw: CSSProperties['borderTopWidth'];
    borderTopWidth: CSSProperties['borderTopWidth'];
    brw: CSSProperties['borderRightWidth'];
    borderRightWidth: CSSProperties['borderRightWidth'];
    bbw: CSSProperties['borderBottomWidth'];
    borderBottomWidth: CSSProperties['borderBottomWidth'];
    blw: CSSProperties['borderLeftWidth'];
    borderLeftWidth: CSSProperties['borderLeftWidth'];

    bc: CSSProperties['borderColor'];
    borderColor: CSSProperties['borderColor'];
    btc: CSSProperties['borderTopColor'];
    borderTopColor: CSSProperties['borderTopColor'];
    brc: CSSProperties['borderRightColor'];
    borderRightColor: CSSProperties['borderRightColor'];
    bbc: CSSProperties['borderBottomColor'];
    borderBottomColor: CSSProperties['borderBottomColor'];
}

export const border = (border?: BorderProps['border']): any => css`
    & {
        border: ${prop(['b', 'border'], border)};
        border-top: ${prop(['bt', 'borderTop'])};
        border-right: ${prop(['br', 'borderRight'])};
        border-bottom: ${prop(['bb', 'borderBottom'])};
        border-left: ${prop(['bl', 'borderLeft'])};

        border-width: ${prop(['bw', 'borderWidth'])};
        border-top-width: ${prop(['btw', 'borderTopWidth'])};
        border-right-width: ${prop(['brw', 'borderRightWidth'])};
        border-bottom-width: ${prop(['bbw', 'borderBottomWidth'])};
        border-left-width: ${prop(['blw', 'borderLeftWidth'])};

        border-color: ${prop(['bc', 'borderColor'])};
        border-top-color: ${prop(['btc', 'borderTopColor'])};
        border-right-color: ${prop(['brc', 'borderRightColor'])};
        border-bottom-color: ${prop(['bbc', 'borderBottomColor'])};
        border-left-color: ${prop(['blc', 'borderLeftColor'])};
    }
`;

border.clean = (props): any =>
    cleanProps(props, [
        'b',
        'border',
        'bt',
        'borderTop',
        'br',
        'borderRight',
        'bb',
        'borderBottom',
        'bl',
        'borderLeft',

        'bw',
        'borderWidth',
        'btw',
        'borderTopWidth',
        'brw',
        'borderRightWidth',
        'bbw',
        'borderBottomWidth',
        'blw',
        'borderLeftWidth',

        'bc',
        'borderColor',
        'btc',
        'borderTopColor',
        'brc',
        'borderRightColor',
        'bbc',
        'borderBottomColor',
        'blc',
        'borderLeftColor',
    ]);
